<template lang="pug">
  v-app.homepage-bg
    the-app-bar
    v-main.v-main-custom
      v-container.fill-height.align-start
        router-view
</template>

<script>
import TheAppBar from '@/components/Layout/TheAppBar.vue';

export default {
  components: {
    TheAppBar,
  },
};
</script>

<style lang="scss">
  .homepage-bg {
    background-image: url(~@/assets/bg5.svg?inline) !important;
    background-size: cover !important;
    background-position: center top !important;
    background-repeat: no-repeat !important;

    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      background-size: auto !important;
      background-position: 41% -13% !important;
      background-repeat: no-repeat !important;
    }
  }
</style>
